import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

searchBoxStyles.search = {
    iconProps: { src: Search },
    cssOverrides: {
        inputSelect: css`
            padding-right: 30px !important;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        `,
    },
};
